import React from 'react';

const REVIEW_STATUS_COLORS: Record<string, string> = {
  pending: 'bg-amber-500/20 text-amber-400',
  approved: 'bg-green-500/20 text-green-400',
  rejected: 'bg-red-500/20 text-red-400',
  flagged: 'bg-orange-500/20 text-orange-400',
};

const REVIEW_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending Review',
  approved: 'Approved',
  rejected: 'Rejected',
  flagged: 'Flagged',
};

export function CertReviewBadge({ status }: { status: string | null | undefined }) {
  if (!status) return null;
  const colors = REVIEW_STATUS_COLORS[status] || 'bg-gray-500/20 text-gray-400';
  const label = REVIEW_STATUS_LABELS[status] || status.replace(/_/g, ' ');
  return (
    <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${colors}`}>
      {label}
    </span>
  );
}

export default CertReviewBadge;
